import { Injectable } from '@angular/core';
import amplitude from 'amplitude-js';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class TrackerService {
  tracker: amplitude.AmplitudeClient;

  constructor() {
    this.tracker = amplitude.getInstance();
    this.tracker.init(environment.amplitude.apiKey);
  }

  private logEvent(name: string, params: any = null) {
    if (!environment.production) {
      return;
    }
    setTimeout(() => {
      try {
        this.tracker.logEvent(name, params);
      } catch (err) {
        console.error('tracking error', err);
      }
    });
  }

  public setUser(user) {
    if (user) {
      this.tracker.setUserId(user.uid);
      this.tracker.setUserProperties({
        email: user.email,
      });
    }
  }

  public trackHome() {
    this.logEvent('general:show-home');
  }

  public trackLogin(provider) {
    this.logEvent('general:login', { provider });
  }

  public trackLogout() {
    this.logEvent('general:logout');
  }

  public trackRegister() {
    this.logEvent('general:register');
  }

  public trackMyImportFile(params: { fileType: string }) {
    this.logEvent('my:import');
  }

  public trackMyImport(params: { bottleCount: number }) {
    this.logEvent('my:import');
  }

  public trackListShow(params: { name: string; url: string }) {
    this.logEvent('list:show', params);
  }

  public trackListShowFromFt(params: { name: string; url: string; ftParams: any }) {
    this.logEvent('list:show', params);
  }

  public trackAddSampleToFtTransaction(params: { name: string; url: string; bottleTitel: string; ftParams: any }) {
    this.logEvent('list:add-sample-to-ft-transaction', params);
  }
}
